import contractDialogCtrl from "../../pages/corporate/contractDialog/contractDialog.controller";
import contractDialogView from "../../pages/corporate/contractDialog/contractDialog.html";
import approveContractDialogCtrl from "../../pages/corporate/approveContractDialog/approveContractDialog.controller";
import approveContractDialogView from "../../pages/corporate/approveContractDialog/approveContractDialog.html";
import cloneDeep from "lodash/fp/cloneDeep";
class Controller {
  constructor(
    $injector,
    $stateParams,
    $state,
    $location,
    $mdDialog,
    Events,
    Authentication
  ) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
    this.$location = $location;
    this.$state = $state;
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.Contracts = $injector.get("Contracts");
    this.priceFields = this.CorporateTransforms.prices;
    this.supplyPriceFields = this.CorporateTransforms.supplyPrice;
    this.$stateParams = $stateParams;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.expanded = true;
    this.contractSteps = cloneDeep(this.CorporateTransforms.contractSteps);
    this.User = $injector.get("User");
    this.userId = Authentication.getValue("owner");
    this.showApprovalOptions = false;
    this.isSelectedContractLoading = false;
  }

  $onInit() {
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.User.get(this.userId).$promise.then(
      (user) => {
        this.showApprovalOptions = user.roles.find(
          (role) => role.name === "contract approver"
        );
      },
      (err) => this.Events.emit(this.errorEvent, err.data)
    );
    this.addContract = (withSelectedContract) => {
      this.$mdDialog.show({
        controller: contractDialogCtrl,
        controllerAs: "$ctrl",
        template: contractDialogView,
        locals: {
          activeContract: withSelectedContract
            ? cloneDeep(this.selectedContract)
            : null,
          contractSteps: this.contractSteps,
          corporateId: this.$stateParams.id,
          options: this.options,
        },
      });
    };
    this.resolvePendingContract = (isApprove) => {
      const confirm = this.$mdDialog.show({
        controller: approveContractDialogCtrl,
        controllerAs: "$ctrl",
        template: approveContractDialogView,
        locals: {
          isApprove,
        },
      });

      confirm
        .then(({ notes }) => {
          const resolvedBy = isApprove ? "approved" : "rejected";
          this.Contracts.changeStatus(this.selectedContract._id, {
            status: resolvedBy,
            notes,
          }).$promise.then(
            () => {
              this.Events.emit(this.showNotificationEvent, {
                message: `Contract has been ${resolvedBy} successfully`,
              });
              this.refreshPage();
            },
            (err) => this.Events.emit(this.errorEvent, err.data)
          );
        })
        .catch(() => {});
    };
  }

  refreshPage() {
    this.$state.transitionTo(
      "corporate",
      { id: this.$stateParams.id },
      { reload: true }
    );
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }
  stopToggleCollapse(event) {
    event.stopPropagation();
  }

  onVersionSelect(contract) {
    this.isSelectedContractLoading = true;
    this.selectedContract = undefined;
    if (this.toggleEvent) this.toggleEvent.stopPropagation();
    this.Contracts.get(contract._id).$promise.then((response) => {
      this.selectedContract = this.CorporateTransforms.reverseJustifyContract(
        response
      );
      this.$location.search("version", this.selectedContract.version);
      this.isSelectedContractLoading = false;
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/contractVersioning/contractVersioning.controller.js